<template>
  <v-card
    class="py-6 px-5 mx-auto elevation-0"
    max-width="900"
  >
    <v-card-title>
      TERMS OF SERVICE AGREEMENT
    </v-card-title>

    <v-card-text class="elevation-0">
      <div class="body-1">
        Updated at: 2020-09-02
      </div>
      <div
        style="
          border: solid 1px #c1c1c1;
          overflow: auto;
          min-height: 100px;
          height: 250px;
          resize: vertical;"
      >
        <section>
          <em>
            PLEASE READ THE FOLLOWING TERMS OF SERVICE AGREEMENT CAREFULLY.
            BY ACCESSING OR USING OUR SITES AND OUR SERVICES,
            YOU HEREBY AGREE TO BE BOUND BY THE TERMS AND
            ALL TERMS INCORPORATED HEREIN BY REFERENCE.
            IT IS THE RESPONSIBILITY OF YOU, THE USER, CUSTOMER,
            OR PROSPECTIVE CUSTOMER TO READ THE TERMS
            AND CONDITIONS BEFORE PROCEEDING TO USE THIS SITE.
            IF YOU DO NOT EXPRESSLY AGREE TO ALL OF THE TERMS AND CONDITIONS,
            THEN PLEASE DO NOT ACCESS OR USE OUR SITES OR OUR SERVICES.
            THIS TERMS OF SERVICE AGREEMENT IS EFFECTIVE AS OF TODAY.
          </em>
        </section>

        <section>
          <p>
            <strong>
              ACCEPTANCE OF TERMS
            </strong>
          </p>

          <p>
            The following Terms of Service Agreement (the "TOS") is
            a legally binding agreement that shall govern the relationship with
            our users and others which may interact or interface with Global Coach Group,
            also known as Global Coach Group (International) Limited, located at 17th Fl.,
            1702A, Glenealy Tower, No. 1 Glenealy, Central,
            Hong Kong and our subsidiaries and affiliates,
            in association with the use of the Global Coach Group’s websites (the “Sites”)
            and Global Coach Group’s products and services (the “Services”),
            which shall be defined below.
          </p>
        </section>

        <section>
          <p>
            <strong>
              DESCRIPTION OF WEBSITE SERVICES OFFERED
            </strong>
          </p>

          <p>
            Any and all visitors to our Sites shall be deemed as "users" of
            the herein contained Services provided for the purpose of this TOS.
          </p>

          <p>
            The user acknowledges and agrees that the Services provided and
            made available through our websites and applications,
            which may include some mobile applications and that those applications and
            numerous other platforms and downloadable programs,
            are the sole property of Global Coach Group. At its discretion,
            Global Coach Group may offer additional website Services, or update,
            modify or revise any current content and Services,
            and this Agreement shall apply to any and all additional Services and/or
            products and any and all updated, modified or revised Services unless
            otherwise stipulated. Global Coach Group does hereby reserve the right to
            cancel and cease offering any of the aforementioned Services and/or products.
            You, as the end user acknowledge, accept and agree that Global Coach Group
            shall not be held liable for any such updates, modifications, revisions,
            suspensions or discontinuance of any of our Services. Your continued use of
            the Services provided, after such posting of any updates, changes, and/or
            modifications shall constitute your acceptance of such updates, changes and/or
            modifications, and as such, an annual review of this Agreement and any and
            all applicable terms and policies should be made by you to
            ensure you are aware of all terms and policies
            currently in effect. Should you not agree to the updated,
            revised or modified terms, you must stop using the
            provided Services forthwith.
          </p>

          <p>
            Furthermore, the user understands, acknowledges and agrees
            that the Services offered shall be provided "AS
            IS" and as such Global Coach Group shall not assume any
            responsibility or obligation for the timeliness,
            missed delivery, deletion and/or any failure to store user
            content, communication, progress or
            personalization settings.
          </p>
        </section>

        <section>
          <p>
            <strong>
              CONTRIBUTIONS TO COMPANY SITES
            </strong>
          </p>

          <p>
            Global Coach Group provides an area for our users to contribute feedback on our Sites.
            When you submit ideas, documents, suggestions and/or proposals ("Contributions") to our
            Sites, you acknowledge and agree that:
          </p>

          <ol type="a">
            <li>
              your contributions do not contain any type of confidential or proprietary information;
            </li>
            <li>
              Global Coach Group shall not be liable or under any obligation to ensure or maintain
              confidentiality, expressed or implied, related to any Contributions;
            </li>
            <li>
              Global Coach Group shall be entitled to make use of and/or disclose any such
              Contributions in any such manner as they may see fit;
            </li>
            <li>
              the contributor's Contributions shall automatically become the sole property of Global
              Coach Group; and
            </li>
            <li>
              Global Coach Group is under no obligation to either compensate or provide any form of
              reimbursement in any manner or nature.
            </li>
          </ol>
        </section>

        <section>
          <p>
            <strong>
              INDEMNITY
            </strong>
          </p>

          <p>
            All users herein agree to hold Global Coach Group, our subsidiaries, affiliates, agents,
            employees, officers, partners and/or licensors blameless or not liable for any claim or
            demand, which may include, but is not limited to, reasonable attorney fees made by any
            third party which may arise from any content a user of our Sites may submit, post,
            modify, transmit or otherwise make available through our Services, the use of Global
            Coach Group’s Services or your connection with these Services, your violations of the
            Terms of Service and/or your violation of any such rights of another person.
          </p>
        </section>

        <section>
          <p>
            <strong>
              COMMERCIAL REUSE OF SERVICES
            </strong>
          </p>

          <p>
            The user herein agrees not to replicate, duplicate, copy, trade, sell, resell nor
            exploit for any commercial reason any part, use of, or access to Global Coach Group's
            Sites and Services.
          </p>
        </section>

        <section>
          <p>
            <strong>
              MODIFICATIONS
            </strong>
          </p>

          <p>
            Global Coach Group shall reserve the right at any time it may deem fit, to modify, alter
            and or discontinue, whether temporarily or permanently, our Services, or any part
            thereof, with or without prior notice. In addition, we shall not be held liable to you
            or to any third party for any such alteration, modification, suspension and/or
            discontinuance of our Services, or any part thereof.
          </p>
        </section>

        <section>
          <p>
            <strong>
              LINKS
            </strong>
          </p>

          <p>
            Either Global Coach Group or any third parties may provide links to other websites
            and/or resources. Thus, you acknowledge and agree that we are not responsible for the
            availability of any such external sites or resources, and as such, we do not endorse nor
            are we responsible or liable for any content, products, advertising or any other
            materials, on or available from such third party sites or resources. Furthermore, you
            acknowledge and agree that Global Coach Group shall not be responsible or liable,
            directly or indirectly, for any such damage or loss which may be a result of, caused or
            allegedly to be caused by or in connection with the use of or the reliance on any such
            content, goods or Services made available on or through any such site or resource.
          </p>
        </section>

        <section>
          <p>
            <strong>
              PROPRIETARY RIGHTS
            </strong>
          </p>

          <p>
            You do hereby acknowledge and agree that Global Coach Group's Services and any essential
            software that may be used in connection with our Services ("Software") shall contain
            proprietary and confidential material that is protected by applicable intellectual
            property rights and other laws. Therefore, except for that which is expressly permitted
            by applicable law or as authorized by Global Coach Group or such applicable licensor,
            you agree not to alter, modify, lease, rent, loan, sell, distribute, transmit,
            broadcast, publicly perform and/or create any plagiaristic works which are based on
            Global Coach Group Services (e.g. Content or Software), in whole or part.
          </p>

          <p>
            Global Coach Group herein has granted you personal, non-transferable and non-exclusive
            rights and/or license to make use of our Software as long as you do not, and shall not,
            allow any third party to duplicate, alter, modify, create or plagiarize work from,
            reverse engineer, reverse assemble or otherwise make an attempt to locate or discern any
            source code, sell, assign, sublicense, grant a security interest in and/or otherwise
            transfer any such right in the Software. Furthermore, you do herein agree not to alter
            or change the Software in any manner, nature or form, and as such, not to use any
            modified versions of the Software, including and without limitation, for the purpose of
            obtaining unauthorized access to our Services. Lastly, you also agree not to access or
            attempt to access our Services through any means other than through the interface which
            is provided by Global Coach Group for use in accessing our Services.
          </p>
        </section>

        <section>
          <p>
            <strong>
              WARRANTY DISCLAIMERS
            </strong>
          </p>

          <p>
            YOU HEREIN EXPRESSLY ACKNOWLEDGE AND AGREE THAT:
          </p>

          <ol type="a">
            <li>
              the use of Global Coach Group’s services and software are at the sole risk by you. Our
              Services and software shall be provided on an "AS IS" and/or "as available" basis.
              Global Coach Group and our subsidiaries, affiliates, officers, employees, agents,
              partners and licensors expressly disclaim any and all warranties of any kind whether
              expressed or implied, including, but not limited to any implied warranties of title,
              merchantability, fitness for a particular purpose and non-infringement.
            </li>
            <li>
              Global Coach Group and our subsidiaries, officers, employees, agents, partners and
              licensors make no such warranties that (i) Global Coach Group’s Services or software
              will meet your requirements; (ii) Global Coach Group’s Services or software shall be
              uninterrupted, timely, secure or error-free; (iii) that such results which may be
              obtained from the use of the Global Coach Group’s Services or software will be
              accurate or reliable; (iv) quality of any products, services, any information or other
              material which may be purchased or obtained by you through our Services or software
              will meet your expectations; and (v) that any such errors contained in the software
              shall be corrected.
            </li>
            <li>
              any information or material downloaded or otherwise obtained by way of Global Coach
              Group’s Services or software shall be accessed by your sole discretion and sole risk,
              and as such you shall be solely responsible for and hereby waive any and all claims
              and causes of action with respect to any damage to your computer and/or internet
              access, downloading and/or displaying, or for any loss of data that could result from
              the download of any such information or material.
            </li>
            <li>
              no advice and/or information, despite whether written or oral, that may be obtained by
              you from Global Coach Group or by way of or from our Services or software shall create
              any warranty not expressly stated in the TOS.
            </li>
          </ol>
        </section>

        <section>
          <p>
            <strong>
              LIMITATION OF LIABILITY
            </strong>
          </p>

          <p>
            YOU EXPLICITLY ACKNOWLEDGE, UNDERSTAND AND AGREE THAT Global Coach Group and our
            subsidiaries, affiliates, officers, employees, agents, partners and licensors shall not
            be liable to you for any punitive, indirect, incidental, special, consequential or
            exemplary damages, including, but not limited to, damages which may be related to the
            loss of any profits, goodwill, use, data and/or other intangible losses, even though we
            may have been advised of such possibility that said damages may occur, and result from:
          </p>

          <ol type="a">
            <li>
              the use or inability to use our service;
            </li>
            <li>
              the cost of procuring substitute goods and services;
            </li>
            <li>
              unauthorized access to or the alteration of your transmissions and/or data;
            </li>
            <li>
              statements or conduct of any such third party on our service;
            </li>
            <li>
              and any other matter which may be related to our service.
            </li>
          </ol>
        </section>

        <section>
          <p>
            <strong>
              RELEASE
            </strong>
          </p>

          <p>
            In the event you have a dispute, you agree to release Global Coach Group (and its
            officers, directors, employees, agents, parent subsidiaries, affiliates, co-branders,
            partners and any other third parties) from claims, demands and damages (actual and
            consequential) of every kind and nature, known and unknown, suspected or unsuspected,
            disclosed and undisclosed, arising out of or in any way connected to such dispute.
          </p>
        </section>

        <section>
          <p>
            <strong>
              THIRD PARTY BENEFICIARIES
            </strong>
          </p>

          <p>
            You herein acknowledge, understand and agree, unless otherwise expressly provided in
            this TOS, that there shall be no third-party beneficiaries to this agreement.
          </p>
        </section>

        <section>
          <p>
            <strong>
              NOTICE
            </strong>
          </p>

          <p>
            Global Coach Group may furnish you with notices, including those with regards to any
            changes to the TOS, including but not limited to email, postings on our website
            Services, or other reasonable means currently known or any which may be herein after
            developed. Any such notices may not be received if you violate any aspects of the TOS by
            accessing our Services in an unauthorized manner. Your acceptance of this TOS
            constitutes your agreement that you are deemed to have received any and all notices that
            would have been delivered had you accessed our Services in an authorized manner.
          </p>
        </section>

        <section>
          <p>
            <strong>
              TRADEMARK INFORMATION
            </strong>
          </p>

          <p>
            You herein acknowledge, understand and agree that all of the Global Coach Group
            trademarks, copyright, trade name, service marks, and other Global Coach Group logos and
            any brand features, and/or product and service names are trademarks and as such, are and
            shall remain the property of Global Coach Group. You herein agree not to display and/or
            use in any manner the Global Coach Group logo or marks without obtaining Global Coach
            Group's prior written consent.
          </p>
        </section>

        <section>
          <p>
            <strong>
              GENERAL INFORMATION
            </strong>
          </p>

          <div>
            <em><i><u>ENTIRE AGREEMENT</u></i></em>
          </div>
          <p>
            This TOS constitutes the entire agreement between you and Global Coach Group and shall
            govern the use of our Services, superseding any prior version of this TOS between you
            and us with respect to Global Coach Group Services. You may also be subject to
            additional terms and conditions that may apply when you use or purchase certain other
            Global Coach Group Services, affiliate Services, third-party content or third-party
            software.
          </p>

          <div>
            <em><i><u>CHOICE OF LAW AND FORUM</u></i></em>
          </div>
          <p>
            It is at the mutual agreement of both you and Global Coach Group with regard to any
            controversy or claim arising out of the TOS, or any breach thereof, including, without
            limitation, any claim that any part of this TOS is invalid, illegal, voidable, or void
            shall be submitted to arbitration in accordance with the Commercial Rules of Arbitration
            at the International Chamber of Commerce in Hong Kong (PRC).
          </p>

          <div>
            <em><i><u>WAIVER AND SEVERABILITY OF TERMS</u></i></em>
          </div>
          <p>
            At any time, should Global Coach Group fail to exercise or enforce any right or
            provision of the TOS, such failure shall not constitute a waiver of such right or
            provision. If any provision of this TOS is found by a court of competent jurisdiction to
            be invalid, the parties nevertheless agree that the court should endeavor to give effect
            to the parties' intentions as reflected in the provision, and the other provisions of
            the TOS remain in full force and effect.
          </p>

          <div>
            <em><i><u>STATUTE OF LIMITATIONS</u></i></em>
          </div>
          <p>
            You acknowledge, understand and agree that regardless of any statute or law to the
            contrary, any claim or action arising out of or related to the use of our Services or
            the TOS must be filed within 3 year(s) after said claim or cause of action arose or
            shall be forever barred.
          </p>
        </section>

        <section>
          <p>
            <strong>
              VIOLATIONS
            </strong>
          </p>

          <p>
            Please report any and all violations of this TOS to Global Coach Group as follows:
          </p>

          <div>Mailing Address:</div>
          <div>Global Coach Group (International) Limited,</div>
          <div>17th Fl., 1702A, Glenealy Tower,</div>
          <div>No. 1 Glenealy,</div>
          <div>Central, Hong Kong</div>
          <p></p>
          <div>
            Telephone:
            <a href="tel:+852-3008-0614">
              +852-3008-0614
            </a>
          </div>
          <p></p>
          <div>
            Email:
            <a href="mailto:Compliance@GlobalCoachGroup.com">
              Compliance@GlobalCoachGroup.com
            </a>
          </div>
        </section>
      </div>
    </v-card-text>

    <v-card-actions class="flex-wrap">
      <div style="width: 100%; text-align: center;">
        <v-checkbox
          v-model="agreed"
          label="Agree with term"
          :disabled="!processFlag"
        >
          <template #label>
            I have read and agree to the Terms of Service Agreement
            and the
            <v-btn
              class="py-0 px-0 mx-1 body-1 text-decoration-underline"
              color="primary"
              text
              :disabled="!processFlag"
              @click.stop="openLink"
            >
              Privacy Policy
            </v-btn>
          </template>
        </v-checkbox>
      </div>
      <div style="width: 100%; text-align: center;">
        <v-btn
          color="primary lighten-2"
          rounded
          :disabled="!agreed || !processFlag"
          :loading="loading"
          width="250"
          @click="toggleAgree"
        >
          Agree
        </v-btn>
        <!--<div
          v-if="!agreed || !processFlag"
          class="pt-4"
        >
          <v-btn
            class="py-1 body-1 text-decoration-underline"
            style="text-transform: unset;"
            color="primary"
            text
            @click="backToService"
          >
            Back to service
          </v-btn>
        </div>-->
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import accountApi from '@/api/account/account';

export default {
  name: 'TermsOfService',

  data: () => ({
    loading: false,
    processFlag: true,
    agreed: false,
  }),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),
  },

  mounted() {
    this.initTerm();
  },

  methods: {
    ...mapActions('account', [
      'getCurrentUser',
    ]),

    async initTerm() {
      if (this.user.is_tos_agreed) {
        this.processFlag = false;
        this.agreed = true;
      }
    },

    async toggleAgree() {
      try {
        this.loading = true;
        const params = { is_tos_agreed: true };
        await accountApi.updateUserProfile(params);
        this.processFlag = false;
        await this.getCurrentUser();
        this.$toast.success('Status successfully changed.');
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$toast.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    openLink() {
      window.open('https://globalcoachgroup.com/privacy-policy/', '_blank');
    },
    // backToService() {
    //   if (this.user.is_staff) {
    //     window.location.href = process.env.VUE_APP_MAM_CLIENT;
    //   } else {
    //     let service;
    //     if (this.$route.query.redirect
    //       && ['gcg_coach', 'gla360'].includes(this.$route.query.redirect)) {
    //       service = this.$route.query.redirect;
    //     } else if (this.user.services.length > 0) {
    //       service = this.user.services[0].service_id;
    //     }
    //
    //     switch (service) {
    //       case 'gcg_coach':
    //         window.location.href = process.env.VUE_APP_COACH_CLIENT;
    //         break;
    //       case 'gla360':
    //         window.location.href = process.env.VUE_APP_GLA_CLIENT;
    //         break;
    //       default:
    //         window.location.href = process.env.VUE_APP_COACH_CLIENT;
    //     }
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
  section {
    padding: 10px;
  }

  li {
    padding: 5px 0;
  }
</style>
